import React from "react";
import './slide_group_card.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {insertHtml} from "../../utils/dom";


class SlideGroupCard extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            isHidden: false
        };
    };

    getLength = (data) =>{
        return data.slider_items.length
    };

    componentRender(data) {
        const settings = {
            dots: (this.getLength(data) > 1),
            infinite: true,
            speed: 500,
            swipeToSlide: true,
            centerMode: true,
            centerPadding: (this.getLength(data) > 3) ? '-20px' : (this.getLength(data) === 3) ? '25%' : '17%',
            slidesToShow: (this.getLength(data) > 3) ? 3 : (this.getLength(data) === 3) ? 2 : this.getLength(data),
            slidesToScroll: (this.getLength(data) <= 1) ? 0 : 1,
            responsive: [
                {
                    breakpoint: 1220,
                    settings: {
                        slidesToShow: (this.getLength(data) < 3) ? this.getLength(data) : 3,
                        slidesToScroll: (this.getLength(data) <= 2) ? 0 : 1,
                        centerMode: (this.getLength(data) < 3),
                        centerPadding: (this.getLength(data) === 2) ? '17%' : '-40px',
                        infinite: true,
                        dots: (this.getLength(data) > 1)
                    }
                },
                {
                    breakpoint: 767,
                        settings: {
                            vertical: true,
                            verticalSwiping: (this.getLength(data) > 3),
                            slidesToShow: (this.getLength(data) < 3) ? this.getLength(data) : 3,
                            slidesToScroll: (this.getLength(data) <= 2) ? 0 : 1,
                            centerMode: (this.getLength(data) <= 2),
                            centerPadding: '-40px',
                            infinite: true,
                            dots: false
                        }
                }
            ]
        };
        return (
            <div id="slide-group-card">
                <div className={'main-slider-container number-slide n-'+(this.getLength(data))}>
                    {(data.title) && <h3 className={'main-title'}>{data.title}</h3>}
                    {(data.content) && <div className={'main-content col-md-6'} {...insertHtml(data.content)}/> }
                    <Slider {...settings}>
                        {data.slider_items.map((item, index) => (
                            <div key={index} className={(this.getLength(data) <= 2) ? 'slider-item offset-item' : 'slider-item'}>
                                <div className={'slider-title'}>{item.title}</div>
                                <div className={'contact-box'}>
                                    <div className={'address'}>
                                        <span className={'maps-icon'}/>
                                        <span>{item.address}</span>
                                    </div>
                                    {(item.content) && <div className={'sub-content'} {...insertHtml(item.content)}/>}
                                    {(item.phone) ?
                                        <div className={'phone'}>
                                            <span className={"phone-icon"}/>
                                            <span>{item.phone}</span>
                                        </div> : null }
                                    {(item.small_content) && <div className={'small-content'} {...insertHtml(item.small_content)}/>}
                                </div>
                                <div className={'link-btn-wrapper'}>
                                    {(item.web_link) && <a href={item.web_link} className={'web-link'} target={'_blank'} rel="noopener noreferrer">Vai al sito</a>}
                                    {(item.show_more) && <a href={item.show_more} className={'btn-white'} target={'_blank'} rel="noopener noreferrer">Vedi i dettagli</a>}
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        )
    }
}

export default SlideGroupCard;
